export const getDocumentIDsFromLocalStorage = () => {
  return localStorage.getItem('documentIDs');
};

export const setDocumentIDsInLocalStorage = (ids: string[]) => {
  localStorage.setItem('documentIDs', JSON.stringify(ids));
};
